// extracted by mini-css-extract-plugin
export var dropdown = "_sq-0";
export var imageWrapper = "_sq-3";
export var itemNameContainer = "_sq-1";
export var productImage = "_sq-2";
export var spinnerWrapper = "_sq-4";